import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useThemeStore } from '@/stores/theme';
import MisteryBoxViewOne from '@/themes/themeOne/misteryBox/misteryBoxView.vue';
import MisteryBoxViewTwo from '@/themes/themeTwo/misteryBox/misteryBoxView.vue';
import MisteryBoxViewThree from '@/themes/themeThree/misteryBox/misteryBoxView.vue';
import MisteryBoxViewFour from '@/themes/themeFour/misteryBox/misteryBoxView.vue';
import { getActivityInformations } from '@/api/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'misteryBoxView',
  emits: ['handleClose'],
  setup(__props, { expose: __expose, emit: __emit }) {

const themeStore = useThemeStore()
const loadingRef = ref()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const show = ref(false)
const depositButtonConfig = ref<any>({})
const mysteryRewardButtonConfig = ref<any>({})
const nonDepositButtonConfig = ref<any>({})
const todayDepositButtonConfig = ref<any>({})
const totalClaimedAmount = ref<number | string>(0)
const totalPrizeAmount = ref<number | string>(0)
    const isEmptyList = ref<boolean>(false)
const dataSet = computed<any>(() => ({
    show: show.value,
    depositButtonConfig: depositButtonConfig.value,
    mysteryRewardButtonConfig: mysteryRewardButtonConfig.value,
    nonDepositButtonConfig: nonDepositButtonConfig.value,
    todayDepositButtonConfig: todayDepositButtonConfig.value,
    totalClaimedAmount: totalClaimedAmount.value,
    totalPrizeAmount: totalPrizeAmount.value,
    isEmptyList: isEmptyList.value
}))
const emits = __emit
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const open = () => {
    show.value = true
    getActivityInfo()
}
const close = () => {
    show.value = false
    emits('handleClose')
}
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "mystery_box"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        const tempObj = res.data;
        depositButtonConfig.value = tempObj.config.depositButton;
        mysteryRewardButtonConfig.value = tempObj.config.mysteryRewardButton;
        nonDepositButtonConfig.value = tempObj.config.nonDepositButton;
        todayDepositButtonConfig.value = tempObj.config.todayDepositButton;
        totalClaimedAmount.value = tempObj.config.totalClaimedAmount || 0;
        totalPrizeAmount.value = tempObj.config.totalPrizeAmount || 0;

        isEmptyList.value = !(depositButtonConfig.value && (depositButtonConfig.value?.available || depositButtonConfig.value?.alreadyClaimed))
            && !(mysteryRewardButtonConfig.value && (mysteryRewardButtonConfig.value?.available || mysteryRewardButtonConfig.value?.alreadyClaimed))
            && !(nonDepositButtonConfig.value && (nonDepositButtonConfig.value?.available || nonDepositButtonConfig.value?.alreadyClaimed))
            && !(todayDepositButtonConfig.value && (todayDepositButtonConfig.value?.available || todayDepositButtonConfig.value?.alreadyClaimed))
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

__expose({
    open
})
onMounted(() => {
    if (themeStore.themeIndex === 1 || themeStore.themeIndex === 3) {
        getActivityInfo()
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(MisteryBoxViewOne, {
            "data-set": dataSet.value,
            onUpdateInfo: getActivityInfo
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(MisteryBoxViewTwo, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open,
            onUpdateInfo: getActivityInfo
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(MisteryBoxViewThree, {
            "data-set": dataSet.value,
            onUpdateInfo: getActivityInfo
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(MisteryBoxViewFour, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open,
            onUpdateInfo: getActivityInfo
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})